import { api } from '@/utils/Request'
import { getSiteConfigByProfile } from '@/utils/SiteConfig'
const ApiPath = "/base-api";
// 获取schoolId（异步）
async function getSchoolId() {
  const curLanguage = `${__SITE_PROFILE__}`;
  const siteConfig = await getSiteConfigByProfile(curLanguage)
  return siteConfig.schoolId
}
// 用户名密码登录
export async function loginByPassword({ username, password }) {
  const schoolId = await getSchoolId()
  return api.post(`${ApiPath}/web/user/login`, {
    schoolId, username, password
  }).then(res => res.data)
}

// 发送验证码
export async function sendLoginCode({ tel, device = 'pc', registerPlace = 'Head' }) {
  const schoolId = await getSchoolId()
  return api.post(`${ApiPath}/web/user/login/tel-code`, {
    schoolId, tel, device, registerPlace
  }).then(res => res.data)
}

// 校验验证码
export async function checkLoginCode({ tel, verifyCode }) {
  const schoolId = await getSchoolId()
  return api.post(`${ApiPath}/web/user/login/tel-code/check`, {
    schoolId, tel, verifyCode
  }).then(res => res.data)
}

// 补填注册信息
export async function fillRegisterInfo({token,fields }) {
  return api.post(`${ApiPath}/web/user/register/fill-info`, fields, {
  }).then(res => res.data)
}

// 找回密码-发送验证码
export async function sendRecoverCode({ account }) {
  const schoolId = await getSchoolId()
  return api.post(`${ApiPath}/v2/user/recover/password/verify/send`, {
    schoolId, account
  }).then(res => res.data)
}

// 找回密码-校验验证码
export async function checkRecoverCode({ account, verifyCode }) {
  const schoolId = await getSchoolId()
  return api.post(`${ApiPath}/v2/user/recover/password/verify/check`, {
    schoolId, account, verifyCode
  }).then(res => res.data)
}

// 找回密码-提交新密码
export async function submitRecoverPassword({ token, password, confirmPassword }) {
  const schoolId = await getSchoolId()
  return api.post(`${ApiPath}/v2/user/recover/password/submit`, {
    schoolId, token, password, confirmPassword
  }).then(res => res.data)
}

// 查询用户基础信息
export async function getUserInfoById(userId) {
  return api.get(`${ApiPath}/v2/users/${userId}/info`).then(res => res.data)
}

/**
 * 校验token有效性
 */
export async function checkTokenAuth(params) {
  return api.post(`/${ApiPath}/web/user/token/auth`, params).then(res => res.data)
}
